module.exports = __webpack_public_path__ + "static/media/GenShinGothic-Medium.f35028c9.ttf";